<template>
  <div>
    <el-card>
      <div slot="header">{{ $t('yourlicense') }}</div>
      <div>
        <el-collapse accordion>
          <LicenseDevices
            :key="index"
            :name="index"
            v-for="(license, index) in licenses"
            :license="license"
            @status="statusChanged($event, license)"
          />
        </el-collapse>
      </div>
    </el-card>
  </div>
</template>

<script>
import LicenseDevices from "@/components/LicenseDevices.vue";
import env from "@/environments/environment";
import axios from "axios";
import { MqttStore, UserStore } from "@/store";

export default {
  name: "Dashboard",
  components: {
    LicenseDevices
  },
  store: { mqtt: MqttStore, user: UserStore },
  async created() {
    let { username, password } = this.$store.user.state;
    if (password == null) {
      const passwd = await this.$prompt(
        $t('enterpassword'),
        $t('toshowstatusenterpassword'),
        { showCancelButton: false, confirmButtonText: $t('agree'), inputType: "password" }
      );
      this.$store.user.dispatch('login', { username, password: passwd.value });
      password = passwd.value
    }
    await this.$store.mqtt.dispatch("connect", {
      url: env.mqtt.url,
      username,
      password
    });

    axios
      .get(`${env.url}/license`)
      .then(({ data: { licenses } }) => (this.licenses = licenses));
  },
  async destroyed() {
    await this.$store.mqtt.dispatch("disconnect");
  },
  methods: {
    statusChanged(status, license) {
      this.$set(
        license,
        "status",
        status.isFine && status.total
          ? "OK"
          : !status.total
          ? "UNKNOWN"
          : !status.ok
          ? "ERROR"
          : "WARNING"
      );

      this.$set(license, "bugStatus", status.bugs);
    }
  },
  data() {
    return {
      licenses: []
    };
  }
};
</script>

<style lang="scss" scoped>
</style>
